import mixpanel from 'mixpanel-browser';

const isBrowser = typeof window !== 'undefined';
const token = process.env.GATSBY_MIXPANEL_TOKEN || process.env.MIXPANEL_TOKEN;

// Near entry of your product, init Mixpanel
if (isBrowser && token) {
  mixpanel.init(token, {
    debug: true, //process.env.GATSBY_ENV.indexOf('dev') > -1,
    track_pageview: true,
    persistence: 'localStorage',

    // whether to ignore or respect the web browser's Do Not Track setting
    ignore_dnt: true,
  });
} else if (isBrowser) {
  // Provide no-op methods when Mixpanel is not configured.
  mixpanel.track = () => {};
  mixpanel.identify = () => {};
  mixpanel.people = { set: () => {} };
}

export default mixpanel;
